<template>
  <div class="arrest-details">
    <div
      v-if="arrests.length < 2 && !loading"
      class="arrest-details__wrapper--one"
    >
      <div class="arrest-details__wrapper">
        <TwoColumnTable
          class="arrest-details__table"
          :data="getTableDataByArrest(currentArrest, true)"
        />
        <div
          class="arrest-details__tip"
          v-html="currentArrest && currentArrest.text"
        ></div>
        <div class="arrest-details__btn--no-bottom">
          <CommonButton @click="redirect(currentArrest.btn_link)">
            {{ currentArrest && currentArrest.btn_text }}
          </CommonButton>
        </div>
      </div>
    </div>
    <CommonAccordeon
      v-else
      @opened="closeOther(i)"
      v-for="(arrest, i) in arrests"
      :key="i"
      v-model:isActive="isAccordeonOpen[i]"
    >
      <template #title>
        {{ arrest.title }}
      </template>
      <template #content>
        <TwoColumnTable
          class="arrest-details__table--multiple"
          :data="getTableDataByArrest(arrest)"
        />
        <div
          v-if="arrest.text"
          class="arrest-details__tip"
          v-html="arrest.text"
        ></div>
        <div v-if="arrest.btn_text" class="arrest-details__btn">
          <CommonButton spaced @click="redirect(arrest.btn_link)">
            {{ arrest.btn_text }}
          </CommonButton>
        </div>
      </template>
    </CommonAccordeon>
    <div
      v-if="page < pageQtn && arrests.length > 2"
      class="arrest-details__more-btn arrest-details__more-btn--spaced"
    >
      <ChipButton @click="loadNextPage" block>
        {{ $t`Показать еще` }}
      </ChipButton>
    </div>
  </div>
</template>

<script>
// TODO: Refactor
import dayjs from "dayjs";
import { fetchArrestData } from "@/api/dashboard";
import TwoColumnTable from "@/components/shared/table/TwoColumnTable";
import CommonButton from "@/components/shared/button/CommonButton";
import ChipButton from "@/components/shared/button/ChipButton";
import CommonAccordeon from "@/components/shared/accordeon/CommonAccordeon";

export default {
  components: {
    TwoColumnTable,
    CommonButton,
    ChipButton,
    CommonAccordeon,
  },
  data() {
    return {
      page: 1,
      pageQtn: 0,
      loading: false,
      isModalOpen: true,
      isAccordeonOpen: {
        /* 0: false, 1: false, 2: false  */
      },
      arrests: [],
      currentArrest: {},
    };
  },
  methods: {
    redirect(link) {
      window.location.href = link;
    },
    async loadNextPage() {
      const { arrests, current_page } = await fetchArrestData(
        this.$route.params.id,
        this.page + 1
      );
      this.arrests = [...this.arrests, ...arrests];
      this.page = current_page;
    },
    getTableDataByArrest(obj, isCurrentArrest) {
      if (!obj) return;
      const result = [
        {
          key: this.$t`Дата`,
          value: `${dayjs(obj.document_date).format("DD.MM.YYYY")}`,
        },
        {
          key: this.$t`Сумма`,
          value: this.$currencyFormatter(obj.arrested_sum, "KZT", 2),
        },
        { key: this.$t`Причина`, value: obj.reason },
        { key: this.$t`Кто выставил`, value: obj.authorized_authority },
      ];
      if (isCurrentArrest) {
        result.unshift({
          key: this.$t`Тип ограничения`,
          value: obj.title,
        });
      }
      return result;
    },
    closeOther(i) {
      Object.keys(this.isAccordeonOpen).forEach((bool, index) => {
        if (index === i) return;
        if (bool) this.isAccordeonOpen[index] = false;
      });
    },
  },
  watch: {
    arrests: {
      immediate: true,
      handler(val) {
        // Строим такую структуру для группы аккордеонов
        // { 0: false, 1: false, 2: false ...}
        const data = val.reduce((acc, current, index) => {
          return { ...acc, [index]: false };
        }, {});
        this.isAccordeonOpen = data;
      },
    },
  },
  async mounted() {
    this.loading = true;
    const { arrests, current_page, page_quantity } = await fetchArrestData(
      this.$route.params.id,
      1
    );
    this.arrests = arrests;
    this.page = current_page;
    this.pageQtn = page_quantity;
    this.loading = false;

    if (this.arrests.length < 2) {
      this.currentArrest = arrests[0];
    }
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.arrest-details {
  font-family: Roboto-Regular;
  padding-bottom: 5px;

  &__wrapper {
    background: white;
    padding: 0 15px 15px;

    &--one {
      background: white;
    }
  }

  &__table {
    padding: 12px 0;
    border-bottom: 1px solid #dbdbdb;

    &--multiple {
      margin-top: -5px;
    }
  }

  &__tip {
    padding: 15px 15px 0;
    text-align: left;
    font-size: 17px;
    line-height: 20px;

    a {
      color: #0089d0;
      text-decoration: none;
    }
  }

  &__more-btn {
    &--spaced {
      padding: 15px;
    }
  }

  &__btn--no-bottom {
    a {
      margin: 15px auto 0px;
    }
  }
}
</style>
